import type { DataItem as DetailedJobTicketsTableDataItem } from '@/components/tables/DetailedJobTicketsTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

function getStatusIcon(shortZammadTicketState?: string): string | undefined {
  if (!shortZammadTicketState) return;
  return shortZammadTicketState.toLocaleLowerCase() === 'new'
    ? 'mdi-email-outline'
    : shortZammadTicketState.toLocaleLowerCase() === 'open'
      ? 'mdi-email-open-outline'
      : shortZammadTicketState.toLocaleLowerCase() === 'closed'
        ? 'mdi-check'
        : shortZammadTicketState.toLocaleLowerCase() === 'merged'
          ? 'mdi-axis-z-arrow'
          : shortZammadTicketState.toLocaleLowerCase() === 'pending reminder'
            ? 'mdi-lan-pending'
            : shortZammadTicketState.toLocaleLowerCase() === 'awaiting dims'
              ? 'mdi-account-clock-outline'
              : 'mdi-progress-question';
}

export function getTableItem(
  shortZammadTicket: openapi.ZammadTicketShortOpenapi,
): DetailedJobTicketsTableDataItem {
  return {
    id: shortZammadTicket.id,
    customer: getStrCell(shortZammadTicket.customer),
    title: getStrCell(shortZammadTicket.title),
    // TODO
    /* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */
    isRfc: !!shortZammadTicket.is_rfc,
    status: getStrCell(shortZammadTicket.state),
    statusIcon: getStatusIcon(shortZammadTicket.state),
    updated: shortZammadTicket.updated_at,
  };
}
